import useIsomorphicLayoutEffect from '@/hooks/useIsomorphicLayoutEffect'
import { isPublic } from '../environment'

export const preventScroll = (prevent) => {
  if (typeof window !== 'undefined') {
    window.document.body.style.overflow = prevent ? 'hidden' : 'auto'
  }
}

export const usePreventScroll = (shouldPrevent = true) => {
  useIsomorphicLayoutEffect(() => {
    preventScroll(shouldPrevent)

    return () => {
      preventScroll(false)
    }
  }, [shouldPrevent])
}

/*
  Gatsby pass incorrect location.hash on init if URL contains also query params, etc.
  Function helps to get always only hash value.
*/
const normalizeHashId = (id) => id.split('?')['0']

export const scrollTo = (id) => {
  try {
    if (!id || id.includes('#access_token')) {
      return null
    }

    const hash = normalizeHashId(id)
    const el = document.querySelector(hash)

    if (el) {
      if (
        isPublic &&
        parseFloat(window.getComputedStyle(el).scrollMarginTop) > 0
      ) {
        return el.scrollIntoView({ block: 'start' })
      }
      return window.scrollTo(0, el.offsetTop - 20)
    }
  } catch (error) {
    return null
  }
}
